<template>
  <aside
    id="logo-sidebar"
    class="fixed top-0 left-0 z-40 w-64 h-screen pt-20 transition-transform -translate-x-full bg-white border-gray-200 sm:translate-x-0 dark:bg-gray-800 dark:border-gray-700"
    aria-label="Sidebar"
  >
    <div class="sidebar-content-wrapper">
      <ul class="space-y-2 font-medium">
        <li v-for="item in filteredMenuItems" :key="item.name">
          <div v-if="item.children">
            <div
              @click="toggleMenu(item.name)"
              class="sidebar-content group transition-colors duration-300 ease-in-out"
              :class="{
                'text-green-500 bg-green-100 dark:text-white dark:bg-gray-700':
                  link === item.name || activeParentMenus.has(item.name),
                'text-slate-400':
                  link !== item.name && !activeParentMenus.has(item.name),
              }"
            >
              <font-awesome-icon
                :icon="['fas', item.icon]"
                class="w-5 h-4 transition duration-75 group-hover:text-green-500 dark:group-hover:text-white transition-colors duration-300 ease-in-out"
                :class="{
                  'text-green-500 dark:text-white':
                    link === item.name || activeParentMenus.has(item.name),
                  'text-slate-400':
                    link !== item.name && !activeParentMenus.has(item.name),
                }"
              />
              <span class="ms-3">{{ item.label }}</span>
              <span class="ml-auto text-gray-500">
                <font-awesome-icon
                  :icon="['fas', 'angle-right']"
                  class="text-xs"
                  :class="{
                    'transform rotate-90 transition-transform duration-300':
                      openedMenus[item.name],
                    'transform rotate-0 transition-transform duration-300':
                      !openedMenus[item.name],
                  }"
                />
              </span>
            </div>
            <transition name="slide-fade">
              <ul v-show="openedMenus[item.name]" class="ml-4">
                <li
                  class="py-1 font-normal"
                  v-for="child in item.children"
                  :key="child.name"
                >
                  <router-link
                    :to="child.path"
                    class="sidebar-child group transition-colors duration-300 ease-in-out"
                    :class="{
                      'text-green-500 dark:text-white': link === child.name,
                      'text-slate-400': link !== child.name,
                    }"
                  >
                    <font-awesome-icon
                      :icon="['fas', child.icon]"
                      class="text-xs transition duration-75 group-hover:text-green-500 dark:group-hover:text-white transition-colors duration-300 ease-in-out"
                      :class="{
                        'text-green-500 dark:text-white': link === child.name,
                        'text-slate-400': link !== child.name,
                      }"
                    />
                    <span class="ms-2">{{ child.label }}</span>
                  </router-link>
                </li>
              </ul>
            </transition>
          </div>
          <div v-else>
            <router-link
              :to="item.path"
              class="sidebar-content group transition-colors duration-300 ease-in-out"
              :class="{
                'text-green-500 bg-green-100 dark:text-white dark:bg-gray-700':
                  link === item.name,
                'text-slate-400': link !== item.name,
              }"
            >
              <font-awesome-icon
                :icon="['fas', item.icon]"
                class="w-5 h-4 transition duration-75 dark:text-gray-400 group-hover:text-green-500 dark:group-hover:text-white transition-colors duration-300 ease-in-out"
                :class="{
                  'text-green-500 dark:text-white': link === item.name,
                  'text-slate-400': link !== item.name,
                }"
              />
              <span class="ms-3">{{ item.label }}</span>
            </router-link>
          </div>
        </li>
      </ul>
    </div>
  </aside>
</template>
<script src="./SideBar.js"></script>
<style scoped>
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

.slide-fade-enter-to,
.slide-fade-leave-from {
  opacity: 1;
  transform: translateY(0);
}

#logo-sidebar {
  transition: transform 0.3s ease-in-out;
}
</style>